const mainCategories = [
  {
    title: '淨零商機',
    subtitle1: '焦點',
    href1: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E6%B7%A8%E9%9B%B6%E6%B0%B8%E7%BA%8C%E6%B7%A8%E9%9B%B6%E5%95%86%E6%A9%9F',
    subtitle2: '簡報',
    href2: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E6%B7%A8%E9%9B%B6%E6%B0%B8%E7%BA%8C%E6%B7%A8%E9%9B%B6%E5%95%86%E6%A9%9F',
  },
  {
    title: '國際趨勢',
    subtitle1: '焦點',
    href1: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E6%B7%A8%E9%9B%B6%E6%B0%B8%E7%BA%8C%E5%9C%8B%E9%9A%9B%E8%B6%A8%E5%8B%A2',
    subtitle2: '簡報',
    href2: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E6%B7%A8%E9%9B%B6%E6%B0%B8%E7%BA%8C%E5%9C%8B%E9%9A%9B%E8%B6%A8%E5%8B%A2',
  },
  {
    title: '產業對策',
    subtitle1: '焦點',
    href1: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E6%B7%A8%E9%9B%B6%E6%B0%B8%E7%BA%8C%E7%94%A2%E6%A5%AD%E5%B0%8D%E7%AD%96',
    subtitle2: '簡報',
    href2: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E6%B7%A8%E9%9B%B6%E6%B0%B8%E7%BA%8C%E7%94%A2%E6%A5%AD%E5%B0%8D%E7%AD%96',
  },
  {
    title: '循環經濟',
    subtitle1: '焦點',
    href1: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E6%B7%A8%E9%9B%B6%E6%B0%B8%E7%BA%8C%E5%BE%AA%E7%92%B0%E7%B6%93%E6%BF%9F',
    subtitle2: '簡報',
    href2: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E6%B7%A8%E9%9B%B6%E6%B0%B8%E7%BA%8C%E5%BE%AA%E7%92%B0%E7%B6%93%E6%BF%9F',
  },
]
export default mainCategories;